<template>
  <div class="container-main">
    <div class="card">
      <div style="padding-right: 0">
        <div class="pt-2">
          <b-button
            class="btn title btn-style"
            @click="viewTypeCase = 'newCase'"
            :style="{
              borderBottom:
                viewTypeCase === 'newCase' ? '2px solid #4DE594' : 'none',
              color: viewTypeCase === 'newCase' ? '#4DE594' : '',
            }"
            >Casos novos</b-button
          >

          <b-button
            class="btn title btn-style"
            @click="viewTypeCase = 'treatedCase'"
            :style="{
              borderBottom:
                viewTypeCase === 'treatedCase' ? '2px solid #4DE594' : 'none',
              color: viewTypeCase === 'treatedCase' ? '#4DE594' : '',
            }"
            >Casos tratados</b-button
          >
        </div>
      </div>
    </div>

    <template v-if="viewTypeCase === 'newCase'">
      <NewCases />
    </template>
    <template v-else>
      <TreatedCases />
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import api from '../../../../services/api';
import NewCases from './new-cases';
import TreatedCases from './treated-cases';

export default {
  components: {
    NewCases,
    TreatedCases
  },

  data() {
    return {
      selected: 'month',
      loading: false,
      selectedProfile: 'all',
      options: [
        { value: null, text: 'Selecione' },
        { value: 'day', text: 'Diário' },
        { value: 'month', text: 'Mensal' },
        { value: 'week', text: 'Semanal' },
        { value: 'quarter', text: 'Trimestral' },
      ],
      chartOptionsPie: {
        chart: {
          type: 'pie',
          height: '350px',
        },
        title: {
          text: '',
        },
        plotOptions: {
          series: {
            innerSize: '60%',
            dataLabels: {
              enabled: false,
              format: '{point.percentage:.1f}%',
            },
            showInLegend: true,
          },
        },
        colors: [
          '#dc3545',
          '#72bcd4',
          '#ffc107',
          '#28a745',
          '#37E688',
          '#000080',
          '#FCBE30',
          '#FF00FF',
          '#e0d1ed',
          '#f0b9cf',
          '#e63c80',
          '#c70452',
          '#4b004c',
          '#cfb698',
          '#ff5d57',
          '#91c68d',
          '#796c86',
          '#ece488',
          '#938172',
        ],
        series: [
          {
            name: 'Status',
            colorByPoint: true,
            data: [],
          },
        ],
      },
      chartOptionsPieChannel: {
        chart: {
          type: 'pie',
          height: '350px',
        },
        title: {
          text: '',
        },
        plotOptions: {
          series: {
            innerSize: '60%',
            dataLabels: {
              enabled: false,
              format: '{point.percentage:.1f}%',
            },
            showInLegend: true,
          },
        },
        colors: [
          '#19AEB3',
          '#72bcd4',
          '#37E688',
          '#191970',
          '#4169E1',
          '#6959CD',
          '#836FFF',
          '#000080',
          '#0000CD',
          '#6495ED',
          '#1E90FF',
        ],
        series: [
          {
            name: 'Status',
            colorByPoint: true,
          },
        ],
      },
      itemsTable: [],
      fields: [
        { key: 'Nome do operador', sortable: true },
        { key: 'Aberto', sortable: true },
        { key: 'Em analise', sortable: true },
        { key: 'Escalonado', sortable: true },
        { key: 'Respondido', sortable: true },
        { key: 'Aberto', sortable: true },
        { key: 'TMR', sortable: true },
      ],
      chartOptionsColumn: {
        chart: {
          type: 'column',
          height: '380px',
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        xAxis: {
          title: {
            text: '',
          },
          categories: [],
        },
        yAxis: {
          title: {
            text: 'Quantidade',
          },
        },
        tooltip: {
          shared: true,
          headerFormat: '<b>Tratativas individuais</b><br></p><br>',
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
            },
          },
        },
        colors: ['#37E688'],
        series: [],
      },
      chartOptionStack: {
        chart: {
          type: 'column',
          height: '380px',
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        xAxis: {
          title: {
            text: '',
          },
          categories: [],
        },
        yAxis: {
          title: {
            text: 'Quantidade',
          },
        },
        tooltip: {
          shared: true,
          headerFormat: '<b>Tratativas individuais</b><br></p><br>',
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
            },
          },
        },
        colors: ['#527BF2', '#19AEB3'],
        series: [],
      },
      optionsProfiles: [
        { value: null, text: 'Selecione' },
        { value: 'all', text: 'Todos' },
        { value: 'promoters', text: 'Promotor' },
        { value: 'passives', text: 'Neutro' },
        { value: 'detractors', text: 'Detrator' },
      ],
      chartOptionsStack: {
        chart: {
          type: 'column',
          height: '380px',
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        xAxis: {
          title: {
            text: '',
          },
          categories: [],
        },
        yAxis: {
          title: {
            text: 'Quantidade',
          },
        },
        tooltip: {
          shared: true,
          headerFormat: '<b>Tratativas individuais</b><br></p><br>',
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            stacking: 'normal',
            dataLabels: {
              enabled: true,
            },
          },
        },
        colors: ['#37E688', '#F2D116', '#FF513D'],
        series: [],
      },
      optionOperator: 'all',
      optionModeTreatment: 'individual',
      optionsOperators: [],
      userAuth: null,
      averageTime: null,
      averagePeriod: 0,
      loadingGraphColumn: false,
      viewType: 'operator',
      viewTypePie: 'actual',
      viewTypeGraph: 'treatment',
      viewTypeCase: 'newCase',
      itemsContact: [],
      fieldsContact: [
        {
          key: 'allStatus',
          label: 'Todos os status',
          class: 'questionTh',
          sortable: true,
        },
        { key: 'progress', class: 'progressTh', label: '' },
        { key: 'percentil', label: '%' },
        { key: 'total', label: 'Total', sortable: true, class: 'totalTh' },
      ],
      checkedPerfil: false,
    };
  },

  computed: {
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
    ...mapState('settings', ['companyAllUsers']),
  },

  methods: {
    ...mapActions('settings', ['getAllUsers']),

    async getDataCards() {
      this.loading = false;

      const response = await api.get('/reports/treatment-monitor/averages', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          profile: this.selectedProfile,
          operator: this.optionOperator,
          treatment: this.optionModeTreatment,
        },
      });

      this.averageTime = response.data.treatmentAverages;

      this.loading = true;
    },

    async getDataPie() {
      const response = await api.get(
        '/reports/treatment-monitor/current-status',
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
            startDate: this.calendarDates.start,
            endDate: this.calendarDates.end,
            ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
            ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
            metric: this.myMetric,
            groupId: this.actionGroupData._id,
            indicator: this.indicatorName,
            indicatorValue: this.indicatorData.value,
            indicatorRange: this.indicatorData.range,
            profile: this.selectedProfile,
            operator: this.optionOperator,
            treatment: this.optionModeTreatment,
          },
        },
      );

      this.chartOptionsPie.series[0].data = response.data.currentStatus;
      this.chartOptionsPieChannel.series[0].data =
        response.data.currentStatusByChannel;
    },

    async getDataTable() {
      const response = await api.get(
        '/reports/treatment-monitor/by-responsible',
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
            startDate: this.calendarDates.start,
            endDate: this.calendarDates.end,
            ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
            ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
            metric: this.myMetric,
            groupId: this.actionGroupData._id,
            indicator: this.indicatorName,
            indicatorValue: this.indicatorData.value,
            indicatorRange: this.indicatorData.range,
            profile: this.selectedProfile,
            operator: this.optionOperator,
            treatment: this.optionModeTreatment,
          },
        },
      );

      const data = response.data;

      this.itemsContact = data.statusByContact;
      this.itemsTable = data.statusByResponsible;
      this.fields = data.fields;
    },

    async getDataChartColumn() {
      this.loadingGraphColumn = false;

      const response = await api.get('/reports/treatment-monitor/by-period', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          profile: this.selectedProfile,
          reportType: this.selected,
          viewByPerfil: this.checkedPerfil,
          operator: this.optionOperator,
          treatment: this.optionModeTreatment,
        },
      });

      const data = response.data;

      this.chartOptionsColumn.series = data.series.profile;
      this.chartOptionsColumn.xAxis.categories = data.categories;
      this.averagePeriod = data.average;

      this.chartOptionStack.series = data.series.treatment;
      this.chartOptionStack.xAxis.categories = data.categories;

      this.loadingGraphColumn = true;
    },

    async getDataViewByProfile() {
      const response = await api.get('/reports/treatment-monitor/by-profile', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          profile: this.selectedProfile,
          reportType: this.selected,
          viewByPerfil: this.checkedPerfil,
          operator: this.optionOperator,
          treatment: this.optionModeTreatment,
        },
      });

      if (response.data.series) {
        this.chartOptionsStack.series = response.data.series[0].data;
        this.chartOptionsStack.xAxis.categories = response.data.categories;
      }
    },
  },

  watch: {
    optionOperator: function watchOperator() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
    },

    checkedPerfil: async function watchCheckedPerfil() {
      const response = await api.get('/reports/treatment-monitor/by-profile', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          profile: this.selectedProfile,
          reportType: this.selected,
          viewByPerfil: this.checkedPerfil,
          operator: this.optionOperator,
          treatment: this.optionModeTreatment,
        },
      });

      if (response.data.series) {
        this.chartOptionsStack.series = response.data.series[0].data;
        this.chartOptionsStack.xAxis.categories = response.data.categories;
      }
    },

    calendarDates: function watchCalendarDates() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    myActionId: function watchMyActionId() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    actionGroupData: function watchActionGroup() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    myIh1: function watchMyIh1() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    myHierarchies1: function watchMyHierarchies1() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    myIh2: function watchMyIh2() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    myHierarchies2: function watchMyHierarchies2() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    myMetric: function watchMyMetric() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    'indicatorData.value': function watchIndicatorData() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    'indicatorData.period': function watchIndicatorPeriod() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    selectedProfile: function watchProfile() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    selected: function filterPeriod() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    await this.getAllUsers({
      userId: this.userAuth._id,
      companyId: this.userAuth.companyId,
      token: this.userAuth.token,
    });

    const allUsers = this.companyAllUsers;

    for (let i = 0; i < allUsers.length; i += 1) {
      if (allUsers[i].text === 'Ninguém') {
        allUsers.splice(i, 1);
      }
    }

    allUsers.unshift({
      text: 'Todos',
      value: 'all',
    });

    this.optionsOperators = allUsers;

    await this.getDataCards();
    await this.getDataPie();
    await this.getDataTable();
    await this.getDataChartColumn();
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.link {
  color: #5299f2;
}

.view-perfil {
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  color: black;
}

.btn-style {
  width: 30%;
  border-radius: 0;
  border: none;
  background: transparent;
  // padding: 15px;
}

.card-body {
  padding: 0;
}

.btn:focus {
  outline: none;
  box-shadow: none;
}

.btn {
  box-shadow: none !important;
}

.header-icon {
  color: $gray;
}

.title {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #242424;
  text-align: center;
  padding-bottom: 15px;
}

.title-card {
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #242424;
  text-transform: uppercase;
}

.align-center {
  align-items: center;
  justify-content: center;
}

.height-content {
  height: 140px;
}

.col-2 {
  width: 220px !important;
  max-width: 220px !important;
  flex: auto !important;
}

.border-card {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  margin-left: 9px;
  margin-right: 9px;
  padding: 15px;
}

.hours {
  font-weight: 700;
  font-size: 18px;
  line-height: 12px;
  color: #242424;
}

.icon {
  color: #4de594;
  width: 28px;
  height: 18px;
}

.container-hour {
  padding-bottom: 10px;
  padding-top: 10px;
}

.number {
  font-weight: 700;
  color: #5f6368;
  font-size: 14px;
  margin-left: 2px;
}

.total-period {
  color: #5f6368;
  font-weight: 300;
  font-size: 14px;
  line-height: 12px;
}

.display-flex {
  display: flex;
  align-items: center;
}

.line {
  background: #f1f1f1;
  margin-left: -11px;
  margin-right: -11px;
  margin-top: 18px;
  height: 28px;
}

.title-main {
  font-weight: 600;
  font-size: 24px;
  line-height: 12px;
  color: #242424;
}

.body {
  background: #e6e6e6;
  padding: 20px;
}

.height {
  min-height: 450px;
  height: 450px;
}

.height-graph {
  min-height: 550px;
  height: 550px;
}

.media-period {
  font-weight: 600;
  font-size: 14px;
  line-height: 12px;
  color: #979797;
}

.number-period {
  font-weight: 700;
  font-size: 24px;
  line-height: 12px;
  color: #242424;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/monitoring-treatment/index.vue